<template>
  <footer class="footer">
    <div class="footer__help">
      <FooterHelp class="footer__container container" />
    </div>

    <div class="footer__main">
      <div class="footer__container container">
        <div class="footer__logo-review">
          <AppLogo class="footer__logo" />

          <div class="footer__review">
            <i18n-t keypath="Rating {0} of 5{1}by {2} customers">
              <b>4.65</b>
              <br>
              <b>4798</b>
            </i18n-t>
          </div>
        </div>

        <FooterContact class="footer__contact" />

        <AppPaymentIcons class="footer__payment-icons" />

        <FooterLinks class="footer__links" />

        <div class="footer__copyright">
          ©{{ new Date().getFullYear() }} {{ $t('Dille & Kamille B.V') }}
        </div>

        <div class="footer__recaptcha">
          <i18n-t keypath="This site is protected by reCAPTCHA and the Google {0} and {1} apply.">
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
            >{{ $t('Privacy policy') }}</a>
            <a
              href="https://policies.google.com/terms                 "
              target="_blank"
            >{{ $t('Terms of Service') }}</a>
          </i18n-t>
        </div>
      </div>
    </div>
  </footer>
</template>

<style src="~layers/app/components/App/Footer.css" />
